export default __webpack_public_path__ + "static/media/mongo.1aca075d.svg";